import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const EVENT_DATE = new Date('2026-11-27T17:30:00+05:30');

function getCountdown() {
  const diff = EVENT_DATE.getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
}

export default function MasterclassModal() {
  const [open, setOpen] = useState(false);
  const [left, setLeft] = useState(getCountdown());

  useEffect(() => {
    if (sessionStorage.getItem('lr-modal-seen')) return;
    const t = setTimeout(() => setOpen(true), 900);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const iv = setInterval(() => setLeft(getCountdown()), 1000);
    return () => clearInterval(iv);
  }, [open]);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem('lr-modal-seen', '1');
  };

  if (!open) return null;

  return (
    <div className="lrm-overlay" role="dialog" aria-modal="true" aria-label="The Capital Room masterclass" onClick={close}>
      <div className="lrm-card" onClick={e => e.stopPropagation()}>
        <button className="lrm-close" aria-label="Close" onClick={close}>&times;</button>
        <p className="lrm-kicker">AQT Direct Limited presents</p>
        <h2 className="lrm-title"><span className="lrm-title-white">The</span> <em>Capital Room</em></h2>
        <p className="lrm-tag">A one-evening masterclass on <strong>how to raise ₹50–500 crore</strong> for your project.</p>

        <div className="lrm-meta">
          <div className="lrm-meta-row"><span className="lrm-meta-k">Venue</span><span className="lrm-meta-v">Taj Lands End, Mumbai</span></div>
          <div className="lrm-meta-row"><span className="lrm-meta-k">Date</span><span className="lrm-meta-v">Friday, 27 November 2026</span></div>
        </div>

        <div className="lrm-timer">
          {[['Days', left.d], ['Hrs', left.h], ['Min', left.m], ['Sec', left.s]].map(([lbl, val]) => (
            <div className="lrm-timer-cell" key={lbl}>
              <span className="lrm-timer-n">{String(val).padStart(2, '0')}</span>
              <span className="lrm-timer-l">{lbl}</span>
            </div>
          ))}
        </div>

        <div className="lrm-btns">
          <Link className="btn-primary" to="/masterclass" onClick={close}>Apply for a seat</Link>
          <button className="btn-ghost" onClick={close}>Maybe later</button>
        </div>
      </div>

      <style>{`
        .lrm-overlay{position:fixed;inset:0;background:rgba(8,20,40,.62);backdrop-filter:blur(4px);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;animation:lrmFade .25s ease both}
        @keyframes lrmFade{from{opacity:0}to{opacity:1}}
        .lrm-card{position:relative;width:100%;max-width:440px;background:radial-gradient(140% 120% at 85% 0%,#1c3d70 0%,#0d2547 60%);color:#fff;border:1px solid rgba(255,255,255,.14);border-radius:18px;padding:36px 32px 30px;box-shadow:0 40px 90px rgba(0,0,0,.45);animation:lrmPop .3s cubic-bezier(.2,.8,.3,1) both}
        @keyframes lrmPop{from{opacity:0;transform:translateY(14px) scale(.97)}to{opacity:1;transform:translateY(0) scale(1)}}
        .lrm-close{position:absolute;top:14px;right:14px;width:30px;height:30px;border-radius:50%;border:1px solid rgba(255,255,255,.2);background:rgba(255,255,255,.05);color:#fff;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}
        .lrm-close:hover{background:rgba(255,255,255,.14)}
        .lrm-kicker{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:var(--teal-light);margin:0 0 10px}
        .lrm-title{font-family:'Cormorant Garamond',serif;font-size:34px;font-weight:500;line-height:1;margin:0 0 12px}
        .lrm-title-white{color:#fff}
        .lrm-title em{font-style:italic;font-weight:600;background:linear-gradient(120deg,#2DD4A0,#8fd4ff);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
        .lrm-tag{font-size:14.5px;line-height:1.5;color:rgba(255,255,255,.85);font-weight:400;margin:0 0 22px}
        .lrm-tag strong{color:var(--teal-light);font-weight:600}
        .lrm-meta{border-top:1px solid rgba(255,255,255,.14);border-bottom:1px solid rgba(255,255,255,.14);padding:14px 0;margin-bottom:20px}
        .lrm-meta-row{display:flex;justify-content:space-between;align-items:center;padding:5px 0;font-size:13.5px}
        .lrm-meta-k{color:rgba(255,255,255,.55);font-family:'DM Sans',sans-serif;font-size:11px;letter-spacing:.08em;text-transform:uppercase}
        .lrm-meta-v{color:#fff;font-weight:500}
        .lrm-timer{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:24px}
        .lrm-timer-cell{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);border-radius:10px;padding:10px 4px;text-align:center}
        .lrm-timer-n{display:block;font-family:'Cormorant Garamond',serif;font-size:22px;font-weight:600;color:var(--teal-light)}
        .lrm-timer-l{display:block;font-family:'DM Sans',sans-serif;font-size:9.5px;letter-spacing:.08em;text-transform:uppercase;color:rgba(255,255,255,.5);margin-top:2px}
        .lrm-btns{display:flex;flex-wrap:wrap;gap:10px}
        .lrm-btns .btn-primary{flex:1;text-align:center}
        .lrm-btns .btn-ghost{background:transparent;border:1px solid rgba(255,255,255,.25);color:#fff;padding:10px 16px;border-radius:8px;cursor:pointer;font-size:14px}
        .lrm-btns .btn-ghost:hover{background:rgba(255,255,255,.08)}
      `}</style>
    </div>
  );
}
